import React from "react";
import { lookupPlanPrice, lookupTruckersPrice, sumAddOnsPrice, formatPrice } from "../../lib/pricing";

export default function PricingCalculator({ planType, planTerm, nvPref, billingTerm, showHST = true, addOns, isTrucker = false }) {
  let plan = 0;

  if (isTrucker) {
    // Truckers pricing
    plan = lookupTruckersPrice(planType, planTerm);
  } else {
    // Regular meal plans
    plan = lookupPlanPrice(planType, planTerm, nvPref, billingTerm);
  }

  const addOnsTotal = sumAddOnsPrice(addOns || [], billingTerm || "Weekly");
  const total = plan + addOnsTotal;

  // if (!planType || !planTerm) {
  //   return null;
  // }

  return (
    <div className="mt-4 rounded-lg border border-orange-200 bg-orange-50 p-4">
      <h3 className="font-semibold mb-2 text-orange-900">Price Preview</h3>
      <div className="space-y-1 text-sm">
        <div className="flex justify-between">
          <span>Plan Price:</span>
          <strong>${formatPrice(plan)}</strong>
        </div>
        <div className="flex justify-between">
          <span>Add-ons Price:</span>
          <strong>${formatPrice(addOnsTotal)}</strong>
        </div>

        <div className="flex justify-between text-lg font-bold mt-2 pt-2 border-t-2 border-orange-300">
          <span>Total:</span>
          <span className="text-orange-600">${formatPrice(total)}</span>
        </div>
      </div>
      <p className="text-xs text-gray-600 mt-2">
        * All prices include HST (13%).
      </p>
    </div>
  );
}
